import { Alert } from '../models/alert.interface';

export interface AdminState {
  readonly alert: Alert | null;
}

export const initialState: AdminState = { alert: null };
